import { ArrowBackRounded } from "@mui/icons-material";
import { Divider, IconButton } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { LabelComp } from "../../../../controls";
import { formatDecimal } from "../../../../hooks/Method";
import moment from "moment";

const Details = ({ value }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div>
      <div className="flex flex-wrap items-center gap-2 justify-between">
        <div>
          <IconButton onClick={handleBack} className="border" size="small">
            <ArrowBackRounded />
          </IconButton>
        </div>
        <div className="flex gap-[10px] items-center text-gray-500">
          <span>
            Return Number:&nbsp;
            <span className="text-[24px] font-bold">{value.returnNo}</span>
          </span>
        </div>
      </div>

      <Divider className="pt-[10px]" />

      <div className="flex flex-wrap justify-between gap-5 mt-[15px]">
        <div className="grid gap-4">
          <LabelComp label="Order No." value={value.orderNo} />
          <LabelComp
            label="Supplier"
            value={`${
              value.supplier.company && value.supplier.company + " | "
            } ${value.supplier.splrName}`}
          />
          <LabelComp
            label="Return By"
            value={`${value.user.firstName} ${value.user.lastName}`}
          />
        </div>
        <div className="grid gap-4">
          <LabelComp
            label="Keep return amount as credit?"
            value={value.keepRefundAsCredit ? "YES" : "NO"}
          />{" "}
          <LabelComp
            label="Return Date"
            value={moment(value.returnDate).format("MMM DD, YYYY, h:mm A")}
          />{" "}
          <LabelComp
            label="Create Date"
            value={moment(value.createDate).format("MMM DD, YYYY, h:mm A")}
          />
        </div>
        <div className="grid gap-4">
          <div>
            <LabelComp
              label="Total Qty"
              value={formatDecimal(value.totalQty, true)}
            />
          </div>
          <div>
            <LabelComp
              label="Total Amount"
              value={`$ ${formatDecimal(value.totalAmount, true)}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
